import { MetricTypes } from '@liquitics/transaction';
import { TrendMetric } from './../trend-metric/trend-metric';
export class ProjectionMetric extends TrendMetric {
    unexpectedIn: number;
    unexpectedOut: number;
    unexpectedAmount: number;
    constructor() {
        super(MetricTypes.UNEXPECTED, 'projection');
    }
}
